import { Cell } from '@table-library/react-table-library/table';

import { comparisonColumns } from '../GscTools/columns';
import { segmentKeyLabel, segmentLabel } from './segments';

/**
 * The columns this report defines on top of the shared GSC tool sets: a key column that reads a
 * returned segment key in words, and the item/value table block 04 states the scope in.
 */

/**
 * The segment's own column.
 *
 * It prints the readable name beside the key Search Console returned rather than instead of it.
 * The key is what every filter and every export uses, so replacing it would leave a table nobody
 * could match against a request — and an appearance enum this app does not recognise has no
 * readable name at all, which is why the key is always the thing that is actually shown.
 */
export function segmentKeyColumn(t, segment) {
    return {
        label: segmentLabel(t, segment),
        key: 'key',
        data: 'key',
        sortType: 'string',
        cellSize: 'minmax(220px, 2.4fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            // The export carries the returned key alone; its label is a column of its own there,
            // so a downloaded row still says exactly what was asked of Search Console.
            if (csvDownload) return data;

            const label = segmentKeyLabel(t, segment, data);
            if (label === data) return data;

            return (
                <span>
                    {label} <small className="text-muted">{data}</small>
                </span>
            );
        },
    };
}

/** The segment table: the shared two-period comparison set, keyed by this report's own column. */
export function segmentColumns(t, { segment, hasPosition }) {
    const shared = comparisonColumns(t, {
        hasPosition,
        keyLabel: segmentLabel(t, segment),
        isUrl: false,
    });

    return [segmentKeyColumn(t, segment), ...shared.slice(1)];
}

export const SCOPE_COLUMNS = (t) => [
    {
        label: t('tools.audience_appearance.coverage.item'),
        key: 'item',
        data: 'item',
        sortType: 'string',
        cellSize: 'minmax(260px, 2fr)',
        Component: Cell,
    },
    {
        label: t('tools.audience_appearance.coverage.value'),
        key: 'value',
        data: 'value',
        sortType: 'string',
        cellSize: 'minmax(220px, 1.6fr)',
        Component: Cell,
        renderCell: ({ data }) => data ?? '—',
    },
];
